import type { FullPostAttributes } from '@platform/data-access'
import slugify from 'slugify'

export const websiteFormatArticleList = (
  articleList: (FullPostAttributes | null | undefined)[]
) => {
  if (!articleList?.length) {
    return []
  }

  return articleList?.map(article => {
    const categoryName = slugify(article?.category?.name || '', { lower: true })

    const featuredImage = article?.featuredImage?.image?.url
    const overwrittenThumbnailImage =
      article?.featuredImage?.image?.formats?.overwrittenThumbnail?.url || ''

    return {
      id: article?.id || '',
      title: article?.title || '',
      href: `/blog/${categoryName}/${article?.slug}`,
      resume: article?.resume || '',
      picture: featuredImage || overwrittenThumbnailImage,
      createdAt: article?.createdAt,
      readingTime: article?.readingTime as number,
      categoryName: article?.category?.name || '',
    }
  })
}
